import React, { useEffect, useState } from 'react';
import {
  FilterSelector,
  FilterSelectorOption
} from '../../../../../shared/components/group-ui/filter-selector/filter-selector.component';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { RouteConfig } from '../../../../../shared/interfaces/routes-config.interface';
import { APP_ROUTES, PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import { getAllReservations } from '../../../../../ReservationModule/shared/services/data.service';
import { ReservationStatus } from '../../../../../shared/enums/reservation-status';
import { isErrorInfo } from '../../../../../shared/interfaces/error-info.interface';
import { ReservationUiModel } from '../../../../../shared/ui-models/reservation.ui-model';
import { ReservationSource } from '../../../../../shared/enums/reservation-souce.enum';
import { ReservationChannel } from '../../../../../shared/enums/reservation-channel.enum';
import { cn } from '../../../../../utils/cn';
import { NotFoundData } from '../../../../../ui/NotFoundData';

type ReservationRowProps = {
  reservation: ReservationUiModel;
};

const tableCellClassName = 'text-[1.2rem] text-gray-700';

const ReservationRow = ({ reservation }: ReservationRowProps) => {
  const handleOpen = () => {
    window.open(
      PUBLIC_PATH +
        (APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH.replace(
          ':id',
          reservation.id
        ),
      '_blank'
    );
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpen();
    }
  };

  return (
    <>
      <TableRow
        className={cn(
          'cursor-pointer transition-colors hover:bg-creams-300/40',
          reservation.status === ReservationStatus.CHECKED_IN_STARTED && 'bg-amber-50'
        )}
        onClick={handleOpen}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        <TableCell className={tableCellClassName}>#{reservation.id}</TableCell>
        <TableCell className={tableCellClassName}>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 text-[2rem]">
              {reservation.source === ReservationSource.BN_ADMIN ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/jpeg/admin.webp`}
                  alt="Admin"
                />
              ) : reservation.source === ReservationSource.BN_APP ? (
                <img
                  className="h-10 w-24 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/bn-app.png`}
                  alt="BN App"
                />
              ) : reservation.source === ReservationSource.BN_WEBSITE ? (
                <img
                  className="h-10 w-24 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/bn-website.png`}
                  alt="BN Website"
                />
              ) : reservation.source === ReservationSource.CHANNEL_MANAGER ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/jpeg/rentals-united.jpeg`}
                  alt="Channel Manager"
                />
              ) : (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/question-mark.png`}
                  alt="Unknown"
                />
              )}
              <ChevronRightIcon fontSize="inherit" />
              {reservation.channel === ReservationChannel.AIRBNB ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/airbnb.png`}
                  alt="Airbnb"
                />
              ) : reservation.channel === ReservationChannel.EXPEDIA ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/expedia.png`}
                  alt="Expedia"
                />
              ) : reservation.channel === ReservationChannel.BOOKING ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/booking.png`}
                  alt="Booking"
                />
              ) : reservation.channel === ReservationChannel.VRBO ? (
                <img
                  className="h-10 w-10 object-contain"
                  src={`${PUBLIC_PATH}/assets/pngs/vrbo.png`}
                  alt="Vrbo"
                />
              ) : (
                <img
                  className="h-10 w-20 object-contain"
                  src={`${PUBLIC_PATH}/assets/svgs/birdnest-logo.svg`}
                  alt="Birdnest"
                />
              )}
            </div>
          </div>
        </TableCell>
        <TableCell className={tableCellClassName}>{reservation.primaryGuestName}</TableCell>
        <TableCell className={tableCellClassName}>
          {reservation.unitName.replace(/(^.*\(|\).*$)/g, '')}
        </TableCell>
        <TableCell className={tableCellClassName}>{reservation.area}</TableCell>

        <TableCell className={tableCellClassName}>
          {new Date(reservation.checkInDate).toDateString()}
        </TableCell>
        <TableCell className={tableCellClassName}>
          {new Date(reservation.checkOutDate).toDateString()}
        </TableCell>
      </TableRow>
      <TableRow></TableRow>
    </>
  );
};

export const ReservationsUpdates: React.FC = () => {
  const [arrivalReservations, setArrivalReservations] = useState<ReservationUiModel[]>([]);
  const [departureReservations, setDepartureReservations] = useState<ReservationUiModel[]>([]);
  const [newReservations, setNewReservations] = useState<ReservationUiModel[]>([]);
  const [currentlyHostingReservations, setCurrentlyHostingReservations] = useState<
    ReservationUiModel[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filters, setFilters] = useState<FilterSelectorOption[]>([
    {
      key: '1',
      text: 'Upcoming in the next 3 days',
      value: 'upcoming',
      count: arrivalReservations?.length || 0
    }
  ]);
  const [answers] = useState<FilterSelectorOption[]>([
    {
      key: '1',
      text: 'Upcoming in the next 3 days',
      value: 'upcoming',
      count: arrivalReservations?.length || 0
    },
    {
      key: '2',
      text: 'Departures in the next 3 days',
      value: 'departure',
      count: departureReservations?.length || 0
    },
    {
      key: '2',
      text: 'New reservations in the last 3 days',
      value: 'new',
      count: newReservations?.length || 0
    },
    {
      key: '4',
      text: 'Currently Hosting',
      value: 'hosting',
      count: currentlyHostingReservations?.length || 0
    }
  ]);

  const getReservationsUpdates = (range: string) => {
    const statusQuery =
      range === 'hosting'
        ? [ReservationStatus.IN_HOUSE]
        : [
            ReservationStatus.CHECKED_IN,
            ReservationStatus.CHECKED_OUT,
            ReservationStatus.CONFIRMATION_PENDING,
            ReservationStatus.IN_HOUSE,
            ReservationStatus.CHECKED_IN_STARTED
          ];
    getAllReservations(
      {
        range,
        statusQuery
      },
      1,
      0
    ).then((response) => {
      if (!isErrorInfo(response)) {
        if (range === 'upcomingCheckIns') setArrivalReservations(response?.reservationList);
        if (range === 'upcomingDepatures') setDepartureReservations(response.reservationList);
        if (range === 'createdRecently') setNewReservations(response.reservationList);
        if (range === 'hosting') setCurrentlyHostingReservations(response.reservationList);
      }
    });
  };
  useEffect(() => {
    setFilters([answers[0]]);
    getReservationsUpdates('upcomingCheckIns');
    getReservationsUpdates('upcomingDepatures');
    getReservationsUpdates('createdRecently');
    getReservationsUpdates('hosting');
    setIsLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderReservations = (reservation: ReservationUiModel[]) => {
    return (
      <div className="max-h-[300px] w-full overflow-y-auto">
        <TableContainer component={Paper} className="shadow-none">
          <Table aria-label="table">
            <TableHead>
              <TableRow>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Reservation #
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Channel
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Guest Name
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Room Name
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Area
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Check In
                </TableCell>
                <TableCell className={cn(tableCellClassName, 'font-semibold text-gray-900')}>
                  Check Out
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reservation?.length > 0 &&
                reservation?.map((reservation: ReservationUiModel) => (
                  <ReservationRow key={reservation.id} reservation={reservation} />
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  };

  return (
    <div className="mb-12 w-full items-center rounded-lg bg-white px-6 py-8 shadow-sm flex flex-col  justify-center">
      <FilterSelector
        choices={filters}
        onSelection={(answer, checked) => {
          if (checked) {
            setFilters([answer]);
          }
        }}
        answers={answers}
      />
      {isLoading ? (
        <div className="flex items-center justify-center py-16 text-gray-500">
          <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
        </div>
      ) : (
        <>
          {filters[0].value === 'upcoming' ? (
            arrivalReservations.length ? (
              renderReservations(arrivalReservations)
            ) : (
              <NotFoundData showMessage={false} />
            )
          ) : (
            <></>
          )}

          {filters[0].value === 'departure' ? (
            departureReservations.length ? (
              renderReservations(departureReservations)
            ) : (
              <NotFoundData showMessage={false} />
            )
          ) : (
            <></>
          )}
          {filters[0].value === 'new' ? (
            newReservations.length ? (
              renderReservations(newReservations)
            ) : (
              <NotFoundData showMessage={false} />
            )
          ) : (
            <></>
          )}
          {filters[0].value === 'hosting' ? (
            currentlyHostingReservations.length ? (
              renderReservations(currentlyHostingReservations)
            ) : (
              <NotFoundData showMessage={false} />
            )
          ) : (
            <></>
          )}
        </>
      )}
    </div>
  );
};
